import CryptoJS from "crypto-js";
import { AUTH_DATA, CLIENT_MODULES_DATA } from "../common/Constants";
import { UserDocType } from "../common/Enumarations";

export const Auth = {


    key: () => CryptoJS.enc.Hex.parse("4033646b666a3538363033242529283e3c4a6543212b2d").toString(CryptoJS.enc.Utf8),

    get: () => {
        var encrypted = localStorage.getItem(AUTH_DATA);
        if (encrypted == null) {
            return null;
        }

        try {
            const aes = CryptoJS.AES;
            const key = Auth.key();
            const utf8 = CryptoJS.enc.Utf8;
            const decrypted = aes.decrypt(encrypted, key, { format: JsonFormatter });
            if (decrypted) {
                return JSON.parse(decrypted.toString(utf8));
            }
        } catch (e) {
            console.log("No Auth Data");
        }
        return null;
    },

    set: (auth) => {

        try {
            const buffer = JSON.stringify(auth);
            const aes = CryptoJS.AES;
            const key = Auth.key();
            const encrypted = aes.encrypt(buffer, key, { format: JsonFormatter });
            localStorage.setItem(AUTH_DATA, encrypted.toString());
        } catch (e) {
            console.log(e);
        }
    },

    getClientModules: () => {
        var encrypted = localStorage.getItem(CLIENT_MODULES_DATA);
        if (encrypted == null) {
            return null;
        }

        try {
            const aes = CryptoJS.AES;
            const key = Auth.key();
            const utf8 = CryptoJS.enc.Utf8;
            const decrypted = aes.decrypt(encrypted, key, { format: JsonFormatter });
            if (decrypted) {
                return JSON.parse(decrypted.toString(utf8));
            }
        } catch (e) {
            console.log("No Auth Data");
        }
        return null;
    },

    setClientModules: (modules) => {

        try {
            const buffer = JSON.stringify(modules);
            const aes = CryptoJS.AES;
            const key = Auth.key();
            const encrypted = aes.encrypt(buffer, key, { format: JsonFormatter });
            localStorage.setItem(CLIENT_MODULES_DATA, encrypted.toString());
        } catch (e) {
            console.log(e);
        }
    }
}

const JsonFormatter = {
    stringify: function (cipherParams) {
        // create json object with ciphertext
        const jsonObj = { ".ae": cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };

        // optionally add iv or salt
        if (cipherParams.iv) {
            jsonObj[".dq"] = cipherParams.iv.toString();
        }

        if (cipherParams.salt) {
            jsonObj[".ry"] = cipherParams.salt.toString();
        }

        // stringify json object
        return JSON.stringify(jsonObj);
    },
    parse: function (jsonStr) {
        // parse json string
        const jsonObj = JSON.parse(jsonStr);

        // extract ciphertext from json object, and create cipher params object
        const cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Base64.parse(jsonObj[".ae"])
        });

        // optionally extract iv or salt

        if (jsonObj[".dq"]) {
            cipherParams.iv = CryptoJS.enc.Hex.parse(jsonObj[".dq"]);
        }

        if (jsonObj[".ry"]) {
            cipherParams.salt = CryptoJS.enc.Hex.parse(jsonObj[".ry"]);
        }

        return cipherParams;
    }
};

export function getTimeSpanFromSeconds(value) {
    const day = parseInt(value / (8 * 60 * 60));
    value = value % (8 * 60 * 60);
    const hour = parseInt(value / (60 * 60));
    value = value % (60 * 60);
    const min = parseInt(value / 60);
    return { day, hour, min, sec: min / 60 };
}

export function getTimeSpanStringFromSeconds(value) {

    const { day, hour, min } = getTimeSpanFromSeconds(value);

    let text = `${day.toString().padStart(2, '0')}:${hour.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`;

    return text;
}

export function getFullTimeSpanStringFromSeconds(value) {

    const { day, hour, min, sec } = getTimeSpanFromSeconds(value);

    let text = `Day : ${day.toString().padStart(2, '0')}Hour: ${hour.toString().padStart(2, '0')} Min: ${min.toString().padStart(2, '0')} Sec: ${sec.toString().padStart(2, '0')}`;

    return text;
}

export function getSecondsFromTimeSpan({ day, hour, min }) {
    const seconds = (+day * 8 * 60 * 60) + (+hour * 60 * 60) + (+min * 60);
    return seconds;
}

export function getYears() {
    return [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027];
}

export function getMonths() {
    return ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
}


function diffHours(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60;
    return Math.round(diff); //Math.abs(Math.round(diff));
}

const processInput = (input) => {
    let result = ""
    let fractionalPart = input.split(".")
    if (fractionalPart.length > 2) return result;
    if (input !== "") {
        let decNum = parseFloat(fractionalPart[0])
        if (Number.isNaN(decNum)) return;
        result = `${decNum}`;
        if (fractionalPart.length === 2) {
            let frac = ""
            if (fractionalPart[1] === "") {
                frac = "."
            } else {
                if (Number.isNaN(parseFloat(fractionalPart[1]))) return result;
                frac = `.${parseFloat(fractionalPart[1])}`
            }
            result = result + frac
        }
    }
    else {
        return 0;
    }
    return result;
}

export function getUserDocType(type) {
    switch (type) {
        case 1:
            return UserDocType.Certificate;
        case 2:
            return UserDocType.NID;
        case 3:
            return UserDocType.BirthCertificate;
        case 4:
            return UserDocType.Resume;
        case 5:
            return UserDocType.Photo;
        case 6:
            return UserDocType.AppointmentLetter;
        case 7:
            return UserDocType.ResignLetter;
        default: break;
    }
}


// WEBPACK FOOTER //
// ./src/common/Common.js